import { Injectable } from '@angular/core';
import { LoaderEnabled } from './loader.service';
import { AppConstants } from '../app.constants';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { ExceptionService } from './exception.service';

interface Action {
    view: boolean;
    add: boolean;
    edit: boolean;
    delete: boolean;
}

interface Node {
    label: string;
    resource: string;
    path: string;
    enabled: boolean;
    actions: Action;
    children?: Node[];
}

@Injectable({
    providedIn: 'root',
})
export class AppScreenService {
    private screens: Node[] = []; // Populate with your full JSON structure
    institueteId: number = 1;

    private screensLoaded = new BehaviorSubject<boolean>(false);
    screensLoaded$ = this.screensLoaded.asObservable();
    getScreensScopes$ = new BehaviorSubject<any[]>([]);

    constructor(
        private http: HttpClient,
        private exceptionService: ExceptionService
    ) {
        // this.getScreenAccessScope(this.institueteId);
    }

    @LoaderEnabled()
    public getScreens(): Observable<any[]> {
        return this.http.get<any[]>(AppConstants.endpoint.screen.base)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.exceptionService.handleError));
    }

    @LoaderEnabled()
    public getScreenAccessScope(institueteId): Observable<any> {
        const instituteId = institueteId || JSON.parse(sessionStorage.getItem("companyId"));
        return this.http.get<any>(`${AppConstants.endpoint.screen.access_control}?instituteId=${instituteId}`)
            .pipe(
                map(res => {
                    this.screens = res;
                    this.getScreensScopes$.next(res);
                    this.screensLoaded.next(true);
                    return res;
                }),
                catchError(this.exceptionService.handleError));
    }

    // Recursive function to find the screen based on label
    findScreen(label: string, nodes: Node[] = this.screens): Node | null {
        for (const node of nodes) {
            if (node.label === label) {
                return node;
            }
            if (node.children) {
                const found = this.findScreen(label, node.children);
                if (found) return found;
            }
        }
        return null; // Return null if no matching screen is found
    }
}
